const avgType = 'AVG';
const potentialKey = 'Bronvermogen_bronsleutel6';
const heatDeliveredKey = 'Geleverd_vermogen_combosleutel_bs6_vs1';
const deltaTKey = 'DeltaT_bronsleutel6';

// The API returns instantaneous power in kW; the graph shows MW.
const kwPerMw = 1000;

function getTimelineEntries(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.features)) return data.features.map(feature => feature.properties ?? feature);
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.results)) return data.results;
  return [];
}

function toNumber(value) {
  if (value === undefined || value === null || value === '') return undefined;
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : undefined;
}

function toMegaWatt(value) {
  const numericValue = toNumber(value);
  return numericValue === undefined ? undefined : numericValue / kwPerMw;
}

/**
 * Normalizes a delta-t timeseries response into chart points. Only the daily
 * AVG entries are kept (MIN/MAX are ignored), and the points are ordered
 * chronologically so the lines run from January to December.
 */
function getTimelinePoints(data) {
  return getTimelineEntries(data)
    .filter(entry => String(entry?.TYPE ?? entry?.type).toUpperCase() === avgType)
    .map((entry) => {
      const timestamp = entry?.Timestamp ?? entry?.timestamp ?? entry?.datum ?? entry?.date;
      const time = timestamp ? new Date(timestamp).getTime() : NaN;

      return {
        id: entry?.ID ?? timestamp,
        timestamp,
        time,
        potential: toMegaWatt(entry?.[potentialKey]),
        heatDelivered: toMegaWatt(entry?.[heatDeliveredKey]),
        deltaT: toNumber(entry?.[deltaTKey]),
      };
    })
    .filter(point => Number.isFinite(point.time))
    .sort((a, b) => a.time - b.time);
}

export {
  getTimelinePoints,
};
